import script from "./JsonPrettifyTD.vue?vue&type=script&setup=true&lang=js"
export * from "./JsonPrettifyTD.vue?vue&type=script&setup=true&lang=js"

import "./JsonPrettifyTD.vue?vue&type=style&index=0&id=280a73d4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-280a73d4"]])

export default __exports__